import { css } from 'aphrodite';
import { Controller } from 'react-hook-form';
import { ISelectBoxOption, SelectBox } from '../../../../../../web/components/SelectBox';
import { IFormField } from '../../../../../models/Api';
import { IFormValues } from '../../utils';
import { styleSheet } from '../styles';

interface IProps {
	field: IFormField<string>;
	control: any;
	formState: any;
	setValue: (name: keyof IFormValues, value: string | number | boolean) => void;
}

export const SelectInput = ({ field, control, formState, setValue }: IProps) => {
	const fieldDropdownOptions = field.options?.map(o => {
		return {
			id: o.id,
			title: o.label,
			value: o.label,
		};
	});

	return (
		<Controller
			name={`customProperties.${field.id}`}
			control={control}
			render={({ field: { ref, ...fieldProps } }) => {
				const onSelectionChanged = (selectedOption: ISelectBoxOption<string>) => {
					setValue(`customProperties.${field.id}` as keyof IFormValues, selectedOption.id);
				};
				const onRenderTriggerTitle = (selectedOption: ISelectBoxOption<string>) => {
					return <span>{selectedOption.title as React.ReactNode}</span>;
				};

				return (
					<>
						<SelectBox
							options={fieldDropdownOptions}
							onRenderSelectedOptionTitle={onRenderTriggerTitle}
							onSelectionChanged={onSelectionChanged}
							placeholder={<span>Select option</span>}
							triggerClassName={css(styleSheet.selectBoxTriggerButton)}
							{...fieldProps}
							selectedOption={fieldDropdownOptions?.find(x => x.id === fieldProps.value) || undefined}
						/>
						{formState?.errors.customProperties?.[field.id] && (
							<p className={css(styleSheet.errorMessage)}>{formState?.errors.customProperties[field.id]?.message}</p>
						)}
					</>
				);
			}}
		/>
	);
};
